import GenerateInvoice from "../utils/GenerateInvoice";
import OrderDetails from "./OrderDetails";
import CancelOrder from "./CancelOrder";
import EditOrder from "./EditOrder";
import LiveFromNow from "../layout/time/LiveFromNow";

const PendingOrders = ({ orders, setModal, onReRender }) => {
  return (
    <div id="pending-scroll" className="order-list-col">
      {Array.isArray(orders) &&
        orders?.map((order, index) => {
          return (
            <div
              className="card p-1 border-dashed-warning"
              key={order?.orderId ?? index}
            >
              <div className="p-2 border-bottom border-block-end-dashed">
                <div className="d-flex align-items-start justify-content-between gap-2">
                  <EditOrder orderId={order?._id} onReRender={onReRender} />
                  <OrderDetails orderId={order?._id} />
                  <CancelOrder orderId={order?._id} onReRender={onReRender} />
                  <GenerateInvoice orderId={order?._id} btnWidth={25} />
                </div>
              </div>
              <div className="card-body">
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    <div className="mb-2 h6 fs-10 text-uppercase">
                      <LiveFromNow
                        date={order?.orderDateTime}
                        interval={60000}
                      />
                    </div>
                    <div className="mb-1 h6">{order?.customerName}</div>
                    <div className="mb-1 h5 fs-10">
                      <i className="ri-phone-line me-1 fw-medium align-middle"></i>
                      {order?.customerPhone}
                    </div>
                  </div>
                  <div className="text-end">
                    <div className="mb-1 h6 fs-10">{order?.orderId}</div>
                    <div className="mb-1 h4 fs-30">
                      <i
                        onClick={() => {
                          setModal({
                            open: true,
                            orderId: order?.orderId,
                            customerName: order?.customerName,
                          });
                        }}
                        className="ri-qr-code-line fw-medium align-middle cursor-pointer"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-3 border-top border-block-end-dashed">
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    <div className="mb-1 h5 fs-10">Note</div>
                    <div className="mb-1 h5 fs-10">
                      {order?.notes ?? `No extra notes`}
                    </div>
                  </div>
                  <div className="text-end">
                    <div className="mb-1 h6 fs-10">{order?.paymentType}</div>
                    <div className="mb-1">
                      <span className="fw-bolder h5 fs-15 me-1">
                        {order?.orderAmount}
                      </span>
                      <span className="h6 fs-10">KWD</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default PendingOrders;
